/* Huvona homepage/collection product-card gallery and clickable colour swatches. */
class HvCardGallery {
  constructor(card) {
    this.card = card;
    this.allSlides = Array.from(card.querySelectorAll('[data-hvc-slide]'));
    this.color = card.querySelector('[data-hvc-swatch][aria-current="true"]')?.dataset.color || '';
    this.slides = [];
    this.index = 0;
    this.count = card.querySelector('[data-hvc-count]');
    this.prev = card.querySelector('[data-hvc-prev]');
    this.next = card.querySelector('[data-hvc-next]');
    this.startX = null;
    this.prev?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); this.show(this.index - 1); });
    this.next?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); this.show(this.index + 1); });
    card.querySelectorAll('[data-hvc-swatch]').forEach((swatch) => swatch.addEventListener('click', (event) => this.selectColour(event, swatch)));
    card.querySelectorAll('.hvc__quick-form').forEach((form) => {
      form.addEventListener('submit', (event) => this.quickAdd(event, form));
    });
    const media = card.querySelector('.hvc__media');
    media?.addEventListener('touchstart', (event) => { this.startX = event.touches[0]?.clientX ?? null; }, { passive: true });
    media?.addEventListener('touchend', (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.startX = null;
        return;
      }
      if (this.startX == null) return;
      const endX = event.changedTouches[0]?.clientX ?? this.startX;
      const distance = endX - this.startX;
      this.startX = null;
      if (Math.abs(distance) < 42) return;
      this.show(this.index + (distance < 0 ? 1 : -1));
    }, { passive: true });
    this.setColour(this.color);
  }

  setColour(color) {
    this.color = color || '';
    const matching = this.allSlides.filter((slide) => slide.dataset.hvcColor === this.color);
    this.slides = matching.length ? matching : this.allSlides;
    this.index = 0;
    this.render();
  }

  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.render();
  }

  showMedia(mediaId) {
    if (!mediaId) return;
    const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
    if (index >= 0) this.show(index);
  }

  render() {
    this.allSlides.forEach((slide) => {
      const active = slide === this.slides[this.index];
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    if (this.count) this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
  }

  async quickAdd(event, form) {
    event.preventDefault();
    event.stopPropagation();

    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin',
      });

      if (!response.ok) throw new Error('Unable to add item');

      const cartItems = document.querySelector('cart-items-component');
      if (cartItems) {
        await customElements.whenDefined('cart-items-component');
        await cartItems.fetchCartData();
      }

      const drawer = document.querySelector('#cart-drawer');
      if (drawer) {
        await customElements.whenDefined('theme-drawer');
        drawer.open();
      }

      button.textContent = 'Added';
    } catch (error) {
      console.warn('[huvona-quick-add]', error);
      button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => {
        button.textContent = originalText;
        if (!button.classList.contains('is-oos')) button.disabled = false;
      }, 1200);
    }
  }

  selectColour(event, swatch) {
    event.preventDefault();
    event.stopPropagation();
    this.card.querySelectorAll('[data-hvc-swatch]').forEach((item) => item.removeAttribute('aria-current'));
    swatch.setAttribute('aria-current', 'true');
    this.setColour(swatch.dataset.color);
    this.showMedia(swatch.dataset.mediaId);
    const url = swatch.dataset.variantUrl;
    if (url) this.card.querySelectorAll('[data-hvc-product-link]').forEach((link) => link.setAttribute('href', url));
    const variantId = swatch.dataset.variantId;
    const wish = this.card.querySelector('[data-wish]');
    if (wish && variantId) wish.dataset.wish = `${this.card.dataset.productId}::${variantId}`;
    const colour = swatch.dataset.color || '';
    this.card.querySelectorAll('[data-hvc-size-color]').forEach((form) => { form.hidden = form.dataset.hvcSizeColor !== colour; });
  }
}

function scanHvCards(scope = document) {
  scope.querySelectorAll('[data-hv-card-gallery]').forEach((card) => {
    if (card.__hvCardGallery) return;
    card.__hvCardGallery = new HvCardGallery(card);
  });
}

window.hvCardGalleryScan = scanHvCards;

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scanHvCards());
else scanHvCards();
document.addEventListener('shopify:section:load', (event) => scanHvCards(event.target));

